// extracted by mini-css-extract-plugin
export default {"Wrapper":"SEmJets4","primary":"jQeJ3jwv"};
    if(module.hot) {
      // 1776432161758
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  